import { RolePermission } from "../graphql/generated.ts";
import { User } from "../types/user.ts";
import { hasPermission } from "./user.ts";

export const canViewCreditLimitMenu = (user: User | undefined | null) =>
  hasPermission(user, RolePermission.CanViewClikData) ||
  hasPermission(user, RolePermission.CanViewRiskFunnelDashboard, true) ||
  hasPermission(user, RolePermission.CanViewCreditUnderwriting, true) ||
  hasPermission(user, RolePermission.CanViewRiskReview, true) ||
  hasPermission(user, RolePermission.CanViewRiskMonitoring, true);
